import { call, put, select, takeEvery } from "redux-saga/effects";
import { createAction } from "redux-actions";
import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";

export const UPDATE_DATE = "saga/UPDATE_DATE";
export const FETCH_REVENUE_TYPE_FILTER = "saga/FETCH_REVENUE_TYPE_FILTER";
export const FETCH_REVENUE_TYPE_FILTER_SUCCESS = "saga/FETCH_REVENUE_TYPE_FILTER_SUCCESS";
export const SET_REVENUE_TYPE_LOADING = "saga/SET_REVENUE_TYPE_LOADING";
export const UPDATE_DATE_SUCCESS = "saga/UPDATE_DATE_SUCCESS";
export const UPDATE_REVENUE_TYPE = "saga/UPDATE_REVENUE_TYPE";
export const UPDATE_REVENUE_TYPE_SUCCESS = "saga/UPDATE_REVENUE_TYPE_SUCCESS";

export const actionCreators = {
  updateDate: createAction(UPDATE_DATE),
  updateRevenueType: createAction(UPDATE_REVENUE_TYPE),
  fetchRevenueTypeFilter: createAction(FETCH_REVENUE_TYPE_FILTER)
};

export default function* watchStars() {
  yield takeEvery(UPDATE_REVENUE_TYPE, updateRevenueType);
  yield takeEvery(FETCH_REVENUE_TYPE_FILTER, fetchRevenueTypeFilter);
}

function* updateRevenueType({ payload }) {
  const { short_url, organization_id } = yield getBaseUrlParams();
  const params = { short_url, organization_id, revenue_type: payload.id };

  try {
    yield put({ type: SET_REVENUE_TYPE_LOADING, payload: true });
    const response = yield call(
      axios.put,
      queryParams.apiVersion + "settings/revenue_type_dropdown",
      { ...params }
    );
    yield put({ type: UPDATE_REVENUE_TYPE_SUCCESS, payload: response.data });
    yield put({ type: SET_REVENUE_TYPE_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchRevenueTypeFilter() {
  const initRequest = yield select((state) => state.dashboardFilters.revenueTypeInitRequest);
  if (initRequest) return;
  yield put({ type: SET_REVENUE_TYPE_LOADING, payload: true });
  const { short_url, organization_id } = yield getBaseUrlParams();
  const params = { short_url, organization_id };

  try {
    const { data } = yield call(
      axios.get,
      queryParams.apiVersion + "settings/revenue_type_dropdown",
      { params }
    );
    yield put({ type: FETCH_REVENUE_TYPE_FILTER_SUCCESS, payload: data });
    yield put({ type: SET_REVENUE_TYPE_LOADING, payload: false });
  } catch (err) {
    console.error(err);
  }
}
